<template>
  <div class="application_form_box">
    <template v-if="isShowBtn">
      <el-form :model="query" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="16">
            <el-form-item label="赛事名称" prop="raceName">
              <el-select
                :popper-append-to-body="false"
                style="width:592px"
                v-model="query.raceName"
                placeholder="请选择赛事"
                @change="selectMatch"
              >
                <el-option
                  v-for="(item,index) in matchList"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="query" ref="form" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="校名">
              <el-input
                disabled
                v-model="query.schoolName"
                style="width:200px"
                placeholder="请输入学校名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="团长">
              <el-input
                :disabled="isUpdate"
                style="width:200px"
                v-model="query.teamLeader"
                placeholder="请输入团长名称"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="组别" prop="groupId">
              <el-select
                :disabled="isUpdate"
                :popper-append-to-body="false"
                style="width:200px"
                @change="selectGroup"
                v-model="query.groupId"
              >
                <el-option
                  v-for="(item,index) in signGroup"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>-->
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="领队" prop="leaderName">
              <el-input
                v-model="query.leaderName"
                :disabled="isUpdate"
                style="width:200px"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机" prop="leaderPhone">
              <el-input
                v-model="query.leaderPhone"
                :disabled="isUpdate"
                style="width:200px"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="邮箱" prop="leaderEmail">
              <el-input
                v-model="query.leaderEmail"
                :disabled="isUpdate"
                style="width:200px"
                placeholder="非必填项"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- prop="headCoachId" -->
            <el-form-item label="主教练">
              <el-select
                clearable
                :disabled="isUpdate"
                :popper-append-to-body="false"
                style="width:200px"
                v-model="query.headCoachId"
                @change="selectCoach"
                placeholder="请选择主教练"
              >
                <el-option
                  v-for="(item,index) in coachList"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机">
              <el-input
                disabled
                v-model="query.headCoachPhone"
                style="width:200px"
                placeholder="自动匹配"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="邮箱" prop="headCoachEmail">
              <el-input
                :disabled="isUpdate"
                v-model="query.headCoachEmail"
                style="width:200px"
                placeholder="非必填项"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- prop="coachIds" -->
            <el-form-item label="教练员">
              <el-select
                :disabled="isUpdate"
                :popper-append-to-body="false"
                style="width:200px"
                v-model="query.coachIds"
                multiple
                placeholder="请选择教练员"
              >
                <el-option
                  v-for="(item,index) in otherCoachList"
                  :key="index"
                  :disabled="item.disabled"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- prop="workerNames" -->
            <el-form-item label="工作人员">
              <el-input
                style="width:200px"
                :disabled="isUpdate"
                v-model="query.workerNames"
                placeholder="请输入工作人员姓名"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table style="width:100%;margin-top:40px" border :data="tableData">
        <el-table-column label="序号" align="center" type="index" width="80"></el-table-column>
        <el-table-column label="组别" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'athleticsGroup','editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectTableGroup($event,$index,'athleticsGroup')"
                style="height:30px"
                v-if="editable[$index].athleticsGroup"
                v-model="row.athleticsGroup"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'athleticsGroup')"
                class="editRemarkInput"
              >
                <el-option
                  v-for="(item,n) in groupList"
                  :key="n"
                  :value="item.value"
                  :label="item.name"
                ></el-option>
              </el-select>
              <span v-else>{{row.athleticsGroup}}</span>
            </div>
            <span v-else>{{row.athleticsGroup}}</span>
          </template>
        </el-table-column>
        <el-table-column label="性别" align="center" width="100">
          <template slot-scope="{row}">
            <span>{{!row.gender && row.gender !== 0?'':row.gender === 0?'女':'男'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" width="150" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'name','editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectAthlete($event,$index,'name')"
                style="height:30px"
                v-if="editable[$index].name"
                v-model="row.name"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'name')"
                class="editRemarkInput"
              >
                <el-option
                  :disabled="item.disabled"
                  v-for="item in athleteList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
              <span v-else>{{row.name}}</span>
            </div>
            <span v-else>{{row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="注册号码" min-width="100" align="center" prop="registerNumber"></el-table-column>
        <el-table-column align="center" min-width="100">
          <template slot="header">
            <p>项目一</p>
            <p>（单项）</p>
          </template>
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'athleticsIndividual1','editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectIndividual($event,$index,'athleticsIndividual1')"
                style="height:30px"
                v-if="editable[$index].athleticsIndividual1"
                v-model="row.athleticsIndividual1"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'athleticsIndividual1')"
                class="editRemarkInput"
              >
                <template v-for="(item,n) in individualObject['individual' + $index]">
                  <template v-if="item.value === '撑杆跳高'">
                    <el-option
                      :key="n"
                      v-if="row.athleticsGroup === '丁组'"
                      :value="item.value"
                      :label="item.name"
                    ></el-option>
                  </template>
                  <template v-else-if="item.value === '110米栏' || item.value === '十项全能'">
                    <el-option
                      v-if="row.gender === 1"
                      :key="n"
                      :disabled="item.disabled"
                      :value="item.value"
                      :label="item.name"
                    ></el-option>
                  </template>
                  <template v-else-if="item.value === '100米栏' || item.value === '七项全能'">
                    <el-option
                      v-if="row.gender === 0"
                      :key="n"
                      :disabled="item.disabled"
                      :value="item.value"
                      :label="item.name"
                    ></el-option>
                  </template>
                  <el-option :key="n" v-else :value="item.value" :label="item.name"></el-option>
                </template>
              </el-select>
              <span v-else>{{row.athleticsIndividual1}}</span>
            </div>
            <span v-else>{{row.athleticsIndividual1}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100">
          <template slot="header">
            <p>项目二</p>
            <p>（单项）</p>
          </template>
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'athleticsIndividual2','editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectIndividual($event,$index,'athleticsIndividual2')"
                style="height:30px"
                v-if="editable[$index].athleticsIndividual2"
                v-model="row.athleticsIndividual2"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'athleticsIndividual2')"
                class="editRemarkInput"
              >
                <template v-for="(item,n) in individualObject['individual' + $index]">
                  <template v-if="item.value === '撑杆跳高'">
                    <el-option
                      :key="n"
                      v-if="row.athleticsGroup === '丁组'"
                      :value="item.value"
                      :label="item.name"
                    ></el-option>
                  </template>
                  <template v-else-if="item.value === '110米栏' || item.value === '十项全能'">
                    <el-option
                      v-if="row.gender === 1"
                      :key="n"
                      :disabled="item.disabled"
                      :value="item.value"
                      :label="item.name"
                    ></el-option>
                  </template>
                  <template v-else-if="item.value === '100米栏' || item.value === '七项全能'">
                    <el-option
                      v-if="row.gender === 0"
                      :key="n"
                      :disabled="item.disabled"
                      :value="item.value"
                      :label="item.name"
                    ></el-option>
                  </template>
                  <el-option :key="n" v-else :value="item.value" :label="item.name"></el-option>
                </template>
              </el-select>
              <span v-else>{{row.athleticsIndividual2}}</span>
            </div>
            <span v-else>{{row.athleticsIndividual2}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="110">
          <template slot="header">
            <p>项目三</p>
            <p>（接力）</p>
          </template>
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'athleticsRelay1','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].athleticsRelay1"
                v-model="row.athleticsRelay1"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'athleticsRelay1')"
                class="editRemarkInput"
              >
                <!-- v-for="(item,n) in relayList" -->
                <el-option :value="relayList[0].value" :label="relayList[0].name"></el-option>
              </el-select>
              <span v-else>{{row.athleticsRelay1}}</span>
            </div>
            <span v-else>{{row.athleticsRelay1}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="110">
          <template slot="header">
            <p>项目四</p>
            <p>（接力）</p>
          </template>
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'athleticsRelay2','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].athleticsRelay2"
                v-model="row.athleticsRelay2"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'athleticsRelay2')"
                class="editRemarkInput"
              >
                <el-option :value="relayList[1].value" :label="relayList[1].name"></el-option>
              </el-select>
              <span v-else>{{row.athleticsRelay2}}</span>
            </div>
            <span v-else>{{row.athleticsRelay2}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="教练员" prop="coachName"></el-table-column>
        <el-table-column label="备注" min-width="100" align="center" prop="remarks">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'remarks','editRemarkInput')}}"
            >
              <el-input
                @keyup.native="$event=>handleKeyUp($event,$index,'remarks','editRemarkInput')"
                maxlength="10"
                v-if="editable[$index].remarks"
                v-model.trim="row.remarks"
                size="mini"
                @blur="$event=>handleBlur($event,$index,'remarks')"
                class="editRemarkInput"
              ></el-input>
              <span v-else>{{row.remarks}}</span>
            </div>
            <span v-else>{{row.remarks}}</span>
          </template>
        </el-table-column>
      </el-table>
      <footer v-if="publishState === 0 || publishState === 2">
        <el-button :loading="loadingData.submitLoading" class="btns" @click="submits('submit')">确认提交</el-button>
        <el-button
          :loading="loadingData.saveLoading"
          class="btns"
          @click="submits('save')"
          style="margin:0 20px;"
        >保存草稿</el-button>
        <el-button class="btns" @click="clearData">清空重置</el-button>
      </footer>
      <footer v-else>
        <span style="font-size:22px">审核状态：</span>
        <span
          :style="{color:publishState === 1?'#1E63B0':'#1CC28C'}"
          style="font-size:18px"
        >{{publishState === 1?'待审核':'审核已通过'}}</span>
      </footer>
    </template>
    <template v-else>
      <div style="padding:160px 0 0 250px">
        <img src="../../assets/img/signUp/no_data.png" alt />
      </div>
    </template>
    <div
      v-if="!hideMask"
      style="width:100%;height:100vh;position:fixed;background:#fff;top:106px;z-index:999999;left:290px;"
    ></div>
  </div>
</template>
<script>
import {
  addSign,
  updateSign,
  getSignDetailBySchool,
  getSignListBySchool
} from "@/api/sign-up-match";
import { getMatchList } from "@/api/sports-management";
import { getCoachList, getAthleteList } from "@/api/athletes.js";
import registerData from "@/assets/json/register.json";
import { table, message } from "@/common/js/mixins";
import { getSession } from "@/utils/storage.js";
import { rule } from "@/utils/utils";
export default {
  mixins: [table, message],
  // 报名表填写
  data() {
    return {
      groupList: [
        {
          name: "甲组",
          value: "甲组"
        },
        {
          name: "乙组",
          value: "乙组"
        },
        {
          name: "丙组",
          value: "丙组"
        },
        {
          name: "丁组",
          value: "丁组"
        }
      ],
      individualObject: {},
      individualList: [
        {
          name: "100米",
          value: "100米",
          disabled: false
        },
        {
          name: "200米",
          value: "200米",
          disabled: false
        },
        {
          name: "400米",
          value: "400米",
          disabled: false
        },
        {
          name: "800米",
          value: "800米",
          disabled: false
        },
        {
          name: "1500米",
          value: "1500米",
          disabled: false
        },
        {
          name: "5000米",
          value: "5000米",
          disabled: false
        },
        {
          name: "10000米",
          value: "10000米",
          disabled: false
        },
        {
          name: "100米栏",
          value: "100米栏",
          disabled: false
        },
        {
          name: "110米栏",
          value: "110米栏",
          disabled: false
        },
        {
          name: "400米栏",
          value: "400米栏",
          disabled: false
        },
        {
          name: "跳高",
          value: "跳高",
          disabled: false
        },
        {
          name: "撑杆跳高",
          value: "撑杆跳高",
          disabled: false
        },
        {
          name: "跳远",
          value: "跳远",
          disabled: false
        },
        {
          name: "三级跳远",
          value: "三级跳远",
          disabled: false
        },
        {
          name: "铅球",
          value: "铅球",
          disabled: false
        },
        {
          name: "铁饼",
          value: "铁饼",
          disabled: false
        },
        {
          name: "标枪",
          value: "标枪",
          disabled: false
        },
        {
          name: "十项全能",
          value: "十项全能",
          disabled: false
        },
        {
          name: "七项全能",
          value: "七项全能",
          disabled: false
        }
      ],
      relayList: [
        {
          name: "4×100米接力",
          value: "4×100米接力"
        },
        {
          name: "4×400米接力",
          value: "4×400米接力"
        }
      ],
      publishState: 0,
      matchList: [],
      hideMask: false,
      isShowBtn: true,
      coachList: [],
      currentProject: {},
      athleteList: [],
      query: {
        id: "",
        teamLeader: "",
        raceName: "",
        matchId: "",
        leaderName: "",
        leaderPhone: "",
        leaderEmail: "",
        headCoachId: "",
        headCoachName: "",
        headCoachPhone: "",
        headCoachEmail: "",
        schoolName: JSON.parse(getSession("userInfo")).schoolName,
        groupId: "",
        coachIds: [],
        coachNames: "",
        workerNames: ""
      },
      titles: [
        "athleticsGroup",
        "name",
        "athleticsIndividual1",
        "athleticsIndividual2",
        "athleticsRelay1",
        "athleticsRelay2",
        "remarks"
      ],
      editable: [],
      otherCoachList: [],
      loadingData: {
        submitLoading: false,
        saveLoading: false
      },
      rules: {
        raceName: [
          {
            required: true,
            message: "赛事名称不能为空",
            trigger: "blur"
          }
        ],
        leaderName: [
          {
            required: true,
            message: "领队姓名不能为空",
            trigger: "change"
          }
        ],
        leaderPhone: [
          { required: true, validator: rule.phone, trigger: "blur" }
        ],
        leaderEmail: [
          {
            validator: rule.email,
            trigger: "blur"
          }
        ],
        headCoachEmail: [
          {
            validator: rule.email,
            trigger: "blur"
          }
        ],
        headCoachId: [
          {
            required: true,
            message: "主教练不能为空",
            trigger: "change"
          }
        ],
        groupId: [
          {
            required: true,
            message: "组别不能为空",
            trigger: "change"
          }
        ],
        coachIds: [
          {
            required: true,
            message: "教练员不能为空",
            trigger: "change"
          }
        ],
        workerNames: [
          {
            required: true,
            message: "工作人员姓名不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    signGroup() {
      return registerData.registGroup;
    },
    // 状态为0或者2 表示草稿、驳回或未发布，此时可以修改，其他状态禁用
    isUpdate() {
      return this.publishState === 0 || this.publishState === 2 ? false : true;
    }
  },
  methods: {
    // 获取赛事列表
    getMatch() {
      getMatchList({
        project: 9,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.matchList = res.list;
          this.isShowBtn = res.list.length === 0 ? false : true;
          this.hideMask = true;
          if (this.$route.query.id) this.selectMatch(this.$route.query.id);
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowBtn = false;
          }
          this.hideMask = true;
        });
    },
    // 生成表格
    makeTable(
      count = this.currentProject.count * this.currentProject.groupId.split(",").length
    ) {
      this.tableData = [];
      this.editable = [];
      for (let i = 0; i < count; i++) {
        this.$set(
          this.individualObject,
          "individual" + i,
          JSON.parse(JSON.stringify(this.individualList))
        );
        this.tableData.push({
          athleticsGroup: "下拉选择",
          gender: "",
          name: "下拉/模糊查找",
          registerNumber: "",
          athleticsIndividual1: "下拉选择",
          athleticsIndividual2: "下拉选择",
          athleticsRelay1: "下拉选择",
          athleticsRelay2: "下拉选择",
          athleteId: "",
          coachName: "",
          remarks: "非必填项"
        });
        let obj = {};
        this.titles.filter(temp => {
          obj[temp] = false;
        });
        this.editable.push(obj);
      }
    },
    // 选择赛事
    selectMatch(value) {
      Object.assign(this.query, this.$options.data().query);
      //   this.athleteList = [];
      this.$refs.form.resetFields();
      let data = {};
      this.matchList.filter(item => {
        if (item.id === value) data = item;
      });
      this.currentProject = data;

      Object.assign(this.query, {
        matchId: data.id,
        raceName: value
      });

      this.getSignDetail(value);
    },
    // 保存/提交
    submits(type) {
      this.$refs.form.validate(valid => {
        if (valid) {
          let data = this.formatData();
          if (!data) return;

          if (!this.query.id) {
            this.loadingData.submitLoading = true;
            addSign({
              ...this.query,
              ...data,
              state: type === "submit" ? 1 : 0
            })
              .then(res => {
                this.loadingData.submitLoading = false;

                this.openSuccess(
                  type === "submit" ? "恭喜你，报名成功！" : "保存成功！"
                );

                this.$router.push({
                  path: "/athletics/athletics-registration-form-view",
                  query: {
                    id: this.query.raceName
                  }
                });
              })
              .catch(err => {
                this.loadingData.submitLoading = false;
              });
          } else {
            if (type === "submit") this.loadingData.submitLoading = true;
            else this.loadingData.saveLoading = true;
            updateSign({
              ...this.query,
              ...data,
              state: type === "submit" ? 1 : 0
            })
              .then(res => {
                if (type === "submit") this.loadingData.submitLoading = false;
                else this.loadingData.saveLoading = false;

                this.openSuccess(
                  type === "submit" ? "恭喜你，报名成功！" : "保存成功！"
                );

                this.$router.push({
                  path: "/athletics/athletics-registration-form-view",
                  query: {
                    id: this.query.raceName
                  }
                });
              })
              .catch(err => {
                if (type === "submit") this.loadingData.submitLoading = false;
                else this.loadingData.saveLoading = false;
              });
          }
        }
      });
    },
    // 清空重置
    clearData() {
      Object.assign(this.query, {
        leaderName: "",
        leaderPhone: "",
        leaderEmail: "",
        headCoachId: "",
        headCoachName: "",
        headCoachPhone: "",
        headCoachEmail: "",
        groupId: "",
        coachIds: [],
        coachNames: "",
        workerNames: "",
        teamLeader: ""
      });
      this.tableData.filter((item, index) => {
        for (let temp in item) {
          if (temp === "name") {
            this.$set(this.tableData[index], temp, "下拉/模糊查找");
          } else if (
            temp === "athleticsGroup" ||
            temp === "athleticsIndividual1" ||
            temp === "athleticsIndividual2" ||
            temp === "athleticsRelay1" ||
            temp === "athleticsRelay2"
          ) {
            this.$set(this.tableData[index], temp, "下拉选择");
          } else if (temp === "remarks") {
            this.$set(this.tableData[index], temp, "非必填项");
          } else {
            this.$set(this.tableData[index], temp, "");
          }
        }
      });
      this.editable.filter((item, index) => {
        for (let temp in item) {
          this.$set(this.editable[index], temp, false);
        }
      });
      this.athleteList = [];
      this.$refs.form.resetFields();
      window.scrollTo(0, 0);
    },
    // 保存参数格式化
    formatData() {
      // 格式化参数
      let { headCoachId, coachIds } = this.query;
      let headCoachName = "";
      let coachNames = [];
      let athleteJson = [];
      let flag = false;
      let data = "";
      this.coachList.filter(item => {
        if (item.id === headCoachId) {
          headCoachName = item.name;
        }
      });
      coachIds.filter(item => {
        this.otherCoachList.filter(temp => {
          if (item === temp.id) {
            coachNames.push(temp.name);
          }
        });
      });
      this.tableData.filter(item => {
        if (item.name !== "下拉/模糊查找") {
          flag = true;
          if (
            item.athleticsIndividual1 === "下拉选择" &&
            item.athleticsIndividual2 === "下拉选择" &&
            item.athleticsRelay1 === "下拉选择" &&
            item.athleticsRelay2 === "下拉选择"
          )
            data = "请选择至少一个项目";
          if (item.athleticsGroup === "下拉选择") data = "请选择组别";
          athleteJson.push({
            athleteId: item.athleteId,
            projectJson: {
              athleticsGroup: item.athleticsGroup,
              athleticsIndividual1:
                item.athleticsIndividual1 === "下拉选择"
                  ? ""
                  : item.athleticsIndividual1,
              athleticsIndividual2:
                item.athleticsIndividual2 === "下拉选择"
                  ? ""
                  : item.athleticsIndividual2,
              athleticsRelay1:
                item.athleticsRelay1 === "下拉选择" ? "" : item.athleticsRelay1,
              athleticsRelay2:
                item.athleticsRelay2 === "下拉选择" ? "" : item.athleticsRelay2
            },
            remarks: item.remarks === "非必填项" ? "" : item.remarks
          });
        }
      });
      if (!flag) return this.openWarn("请添加运动员后进行操作!");
      if (data) return this.openWarn(data);
      return {
        headCoachName,
        coachIds: coachIds.join(","),
        coachNames: coachNames.join(","),
        athleteJson: JSON.stringify(athleteJson)
      };
    },
    // 输入框监听键盘事件
    handleKeyUp(e, index, key, className) {
      if (e.key === "ArrowRight") {
        this.arrowRight(index, key, className);
      } else if (e.key === "ArrowLeft") {
        this.arrowLeft(index, key, className);
      } else if (e.key === "ArrowUp") {
        this.arrowTop(index, key, className);
      } else if (e.key === "ArrowDown") {
        this.arrowDown(index, key, className);
      } else if (e.key === "Tab") {
        this.arrowTab(index, key, className);
      }
    },
    // 输入框tab监听
    arrowTab(index, key, className) {
      let num = this.titles.indexOf(key);
      let moveRow = 0;
      let moveName = "";

      if (index === this.tableData.length - 1 && num === this.titles.length - 1)
        return;
      else {
        if (num === this.titles.length - 1) {
          moveRow = index + 1;
          //   moveName = this.titles[1];
          moveName = key;
        } else {
          moveRow = index;

          moveName = key;
          //   moveName = this.titles[num + 1];
        }
      }

      this.changeNum(moveRow, moveName, className);
    },
    // 输入框监听上箭头事件
    arrowTop(index, key, className) {
      let moveRow = 0;
      // 到第一排时，return 反之，则到上一排的第一个输入位置
      if (index === 0) return;
      else moveRow = index - 1;

      this.changeNum(moveRow, key, className);
    },
    // 输入框监听下箭头事件
    arrowDown(index, key, className) {
      let moveRow = 0;
      // 到第一排时，return 反之，则到上一排的第一个输入位置
      if (index === this.tableData.length - 1) return;
      else moveRow = index + 1;

      this.changeNum(moveRow, key, className);
    },
    // 输入框监听左箭头事件
    arrowLeft(index, key, className) {
      let num = this.titles.indexOf(key);
      let moveRow = 0;
      let moveName = "";
      // 到第一项时，则到上一排的第一个输入位置
      if (num === 6) {
        if (index === 0) return;
        moveRow = index - 1;
        moveName = this.titles[this.titles.length - 1];
      } else {
        moveRow = index;
        // moveName = this.titles[num - 1];
        moveRow = key;
      }

      this.changeNum(moveRow, moveName, className);
    },
    // 输入框监听右箭头事件
    arrowRight(index, key, className) {
      let num = this.titles.indexOf(key);
      let moveRow = 0;
      let moveName = "";
      // 到最后一项时，则到下一排的第一个输入位置
      if (num === this.titles.length - 1) {
        if (index === this.tableData.length - 1) return;
        moveRow = index + 1;
        // moveName = this.titles[1];
        moveName = key;
      } else {
        moveRow = index;
        // moveName = this.titles[num + 1];
        moveName = key;
      }
      this.changeNum(moveRow, moveName, className);
    },
    // 选择组别（表格）
    selectTableGroup(value, num, col) {
      if (!value) {
        Object.assign(this.tableData[num], {
          athleticsGroup: "下拉选择"
        });
      }
      Object.assign(this.tableData[num], {
        athleticsIndividual1: "下拉选择",
        athleticsIndividual2: "下拉选择"
      });
      setTimeout(() => {
        this.editable[num][col] = false;
      }, 200);
    },
    // 选择项目（单项）
    selectIndividual(value, num, col) {
      let flag = false;
      // 清空所选项目时，判断项目一和项目二值是否为下拉选择，并设置对应项目列表是否禁用，以及遍历表格，设置对应运动员的项目列表
      if (!value) {
        this.$set(this.tableData[num], col, "下拉选择");

        let result =
          this.tableData[num].athleticsIndividual1 === "下拉选择" &&
          this.tableData[num].athleticsIndividual2 === "下拉选择";
        this.$set(
          this.individualObject["individual" + num][
            this.individualObject["individual" + num].length - 1
          ],
          "disabled",
          !result
        );
        this.$set(
          this.individualObject["individual" + num][
            this.individualObject["individual" + num].length - 2
          ],
          "disabled",
          !result
        );
        flag = false;
      } else {
        // 选择项目为十项全能或者七项全能时，遍历表格 清空其他列相同运动员信息
        if (value === "十项全能" || value === "七项全能") {
          this.$set(
            this.tableData[num],
            col === "athleticsIndividual2"
              ? "athleticsIndividual1"
              : "athleticsIndividual2",
            "下拉选择"
          );
          this.tableData.filter((item, i) => {
            if (item.athleteId === this.tableData[num].athleteId && i !== num) {
              //   this.clearRow(i);
            }
          });
          flag = true;
        }
        // 反之，
        else {
          // 判断当前项目为项目一时，项目二是否为十项全能或七项全能，如果是，则初始化项目二的值
          if (
            col === "athleticsIndividual1" &&
            (this.tableData[num].athleticsIndividual2 === "十项全能" ||
              this.tableData[num].athleticsIndividual2 === "七项全能")
          ) {
            this.$set(this.tableData[num], "athleticsIndividual2", "下拉选择");
            flag = false;
          }
          // 判断当前项目为项目二时，项目一是否为十项全能或七项全能，如果是，则初始化项目一的值
          else if (
            col === "athleticsIndividual2" &&
            (this.tableData[num].athleticsIndividual1 === "十项全能" ||
              this.tableData[num].athleticsIndividual1 === "七项全能")
          ) {
            this.$set(this.tableData[num], "athleticsIndividual1", "下拉选择");
            flag = false;
          }
          // 由于选择其他项目后，不能同时选择十项全能及七项全能，故禁用这两项
          //   this.$set(
          //     this.individualObject["individual" + num][
          //       this.individualObject["individual" + num].length - 1
          //     ],
          //     "disabled",
          //     true
          //   );
          //   this.$set(
          //     this.individualObject["individual" + num][
          //       this.individualObject["individual" + num].length - 2
          //     ],
          //     "disabled",
          //     true
          //   );
        }
      }
      this.disableAthlete(num, flag);
      setTimeout(() => {
        this.editable[num][col] = false;
      }, 200);
    },
    // 根据运动员对应单项是否为十项全能或七项全能，禁用对应运动员选择项
    disableAthlete(num, bool) {
      this.athleteList.filter((item, index) => {
        if (item.id === this.tableData[num].athleteId) {
          this.$set(this.athleteList[index], "disabled", bool);
        }
      });
    },
    // 选择运动员
    selectAthlete(value, num, col, details = false) {
      if (value) {
        this.athleteList.filter((item, index) => {
          this.$set(this.athleteList[index], "disabled", false);
        });
        let arr = [];
        let tableIndex = [];
        if (!details) this.$set(this.tableData[num], "athleteId", "");

        this.tableData.filter((item, i) => {
          for (let j = 0; j < this.athleteList.length; j++) {
            if (
              item.name === this.athleteList[j].id ||
              item.athleteId === this.athleteList[j].id
            ) {
              for (let k in this.athleteList[j]) {
                if (item.hasOwnProperty(k) && k !== "remarks") {
                  this.$set(item, k, this.athleteList[j][k]);
                }
                this.$set(item, "athleteId", this.athleteList[j].id);
              }
              this.$set(this.athleteList[j], "numbers", tableIndex);
              arr.push(this.athleteList[j]);
              break;
            }
          }
        });
        if (
          this.tableData[num].gender !== "" &&
          this.tableData[num].gender !== arr[0].gender &&
          !details
        ) {
          Object.assign(this.tableData[num], {
            athleticsIndividual1: "下拉选择",
            athleticsIndividual2: "下拉选择",
            athleticsRelay1: "下拉选择",
            athleticsRelay2: "下拉选择"
          });
        }
      } else {
        this.$set(
          this.individualList[this.individualList.length - 1],
          "disabled",
          false
        );
        this.$set(
          this.individualList[this.individualList.length - 2],
          "disabled",
          false
        );
        this.athleteList.filter((item, index) => {
          if (item.id === this.tableData[num].athleteId) {
            this.$set(this.athleteList[index], "disabled", false);
          }
        });

        this.$set(this.tableData[num], "athleteId", "");
        for (let item in this.tableData[num]) {
          if (item === "number" || item === "position") {
            this.$set(this.tableData[num], item, "输入");
          } else if (item === "name")
            this.$set(this.tableData[num], item, "下拉/模糊查找");
          else if (
            item === "athleticsIndividual1" ||
            item === "athleticsIndividual2" ||
            item === "athleticsRelay1" ||
            item === "athleticsRelay2"
          )
            this.$set(this.tableData[num], item, "下拉选择");
          else if (item === "remarks")
            this.$set(this.tableData[num], item, "非必填项");
          else if (item !== "athleticsGroup")
            this.$set(this.tableData[num], item, "");
        }
      }
      setTimeout(() => {
        this.editable[num][col] = false;
      }, 200);
    },
    // 遍历表格每一项，当出现重复运动员时，则根据每一项运动员对应项目，禁用对应项目列表的全能项
    ergodic(num) {
      this.tableData.filter((item, index) => {
        if (item.athleteId === this.tableData[num].athleteId && index !== num) {
          this.$set(
            this.individualObject["individual" + num][
              this.individualObject["individual" + num].length - 1
            ],
            "disabled",
            true
          );
        }
      });
    },
    // 重置某行数据
    clearRow(num) {
      for (let item in this.tableData[num]) {
        if (item === "number" || item === "position") {
          this.$set(this.tableData[num], item, "输入");
        } else if (item === "name")
          this.$set(this.tableData[num], item, "下拉/模糊查找");
        else if (
          item === "athleticsIndividual1" ||
          item === "athleticsIndividual2" ||
          item === "athleticsRelay1" ||
          item === "athleticsRelay2"
        )
          this.$set(this.tableData[num], item, "下拉选择");
        else if (item === "remarks")
          this.$set(this.tableData[num], item, "非必填项");
        else if (item !== "athleticsGroup")
          this.$set(this.tableData[num], item, "");
      }
    },
    // 表格输入框离开焦点
    handleBlur(e, index, col) {
      setTimeout(() => {
        if (col == "remarks" && this.tableData[index][col] === "") {
          this.$set(
            this.tableData[index],
            col,
            col === "remarks" ? "非必填项" : "输入"
          );
        } else if (col == "name" && this.tableData[index][col] === "") {
          this.$set(this.tableData[index], col, "下拉/模糊查找");
        } else if (
          (col == "athleticsGroup" ||
            col == "athleticsIndividual1" ||
            col == "athleticsIndividual2" ||
            col == "athleticsRelay1" ||
            col == "athleticsRelay2") &&
          this.tableData[index][col] === ""
        ) {
          this.$set(this.tableData[index], col, "下拉选择");
        }
        this.editable[index][col] = false;
      }, 200);
    },
    // 表格点击
    changeNum(index, row, className) {
      if (
        (row == "athleticsIndividual1" ||
          row == "athleticsIndividual2" ||
          row == "athleticsRelay1" ||
          row == "athleticsRelay2") &&
        (!this.tableData[index].athleteId ||
          this.tableData[index].athleticsGroup === "下拉选择")
      ) {
        return this.openWarn("选择组别及运动员获取完整选择项");
      }
      this.editable.filter(item => {
        for (let temp in item) item[temp] = false;
      });
      this.editable[index][row] = true;
      if (
        this.tableData[index][row] === "下拉/模糊查找" ||
        this.tableData[index][row] === "非必填项" ||
        this.tableData[index][row] === "下拉选择"
      )
        this.$set(this.tableData[index], row, "");
      //让input自动获取焦点
      this.$nextTick(() => {
        var editInputList = document.getElementsByClassName(className);
        if (
          row === "name" ||
          row === "athleticsGroup" ||
          row === "athleticsIndividual1" ||
          row === "athleticsIndividual2" ||
          row === "athleticsRelay1" ||
          row === "athleticsRelay2"
        )
          editInputList[0].children[0].children[0].focus();
        else {
          editInputList[0].children[0].focus();
        }
      });
    },
    // 选择组别，并获取运动员列表
    selectGroup(value) {
      this.getAthleteLists();
    },
    // 获取教练员列表
    getCoachLists() {
      getCoachList({})
        .then(res => {
          this.coachList = [...res];
          res.filter(item => {
            item.disabled = false;
          });
          this.otherCoachList = [...res];
        })
        .catch(err => {});
    },
    // 选择主教练员后获取对应电话填入
    selectCoach(value) {
      this.$set(this.query, "coachIds", []);

      this.otherCoachList.filter(temp => {
        temp.disabled = false;
      });
      if (value) {
        this.coachList.filter(item => {
          if (item.id === value) {
            this.query.headCoachPhone = item.phone;
          }
        });
        this.otherCoachList.filter(temp => {
          if (value === temp.id) {
            temp.disabled = true;
          }
        });
        let _field = this.$refs["form"].fields;
        _field.map(i => {
          if (i.prop === "coachIds") {
            //通过prop属性值相同来判断是哪个输入框，比如：要移除prop为'user'
            i.resetField();
            return false;
          }
        });
      }
    },
    // 获取当前赛事运动员列表
    getAthleteLists() {
      getAthleteList({
        pageNo: 1,
        pageSize: 999,
        effective: 1,
        isOld:0,
        groupId: this.query.groupId,
        isPass: 1,
        gender:
          this.currentProject.gender === -1 ? "" : this.currentProject.gender
      })
        .then(res => {
          if (res.list.length === 0) {
            this.openWarn("暂无运动员数据");
          }
          res.list.filter(item => {
            item.disabled = false;
          });
          this.tableData.filter((item, index) => {
            for (let temp in item) {
              if (temp === "name") {
                this.$set(this.tableData[index], temp, "下拉/模糊查找");
              } else if (temp === "remarks") {
                this.$set(this.tableData[index], temp, "非必填项");
              } else {
                this.$set(this.tableData[index], temp, "");
              }
            }
          });
          this.editable.filter((item, index) => {
            for (let temp in item) {
              this.$set(this.editable[index], temp, false);
            }
          });

          this.athleteList = [...res.list];
        })
        .catch(err => {});
    },
    // 获取当前赛事运动员列表（草稿）
    getAthleteListByDraft() {
      return new Promise((resolve, reject) => {
        getAthleteList({
          pageNo: 1,
          pageSize: 999,
          isPass: 1,
          effective: 1,
          isOld:0,
          groupId: this.query.groupId,
          gender:
            this.currentProject.gender === -1 ? "" : this.currentProject.gender
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取详情，如果有数据，则表示已经提交或草稿数据，如果审核已通过，则修改表格显示数量
    getSignDetail(id) {
      getSignDetailBySchool({ matchId: id })
        .then(res => {
          if (res) {
            this.publishState = res.state;
            Object.assign(this.query, {
              workerNames: res.workerNames,
              groupId: res.groupId,
              leaderName: res.leaderName,
              leaderPhone: res.leaderPhone,
              leaderEmail: res.leaderEmail,
              headCoachEmail: res.headCoachEmail,
              headCoachId: res.headCoachId,
              headCoachPhone: res.headCoachPhone,
              teamLeader: res.teamLeader,
              headCoachName: res.headCoachName,
              coachIds: !res.coachIds ? [] : res.coachIds.split(","),
              id: res.id
            });
            this.getAthleteListByDraft()
              .then(data => {
                data.list.filter(item => {
                  item.disabled = false;
                });

                this.athleteList = [...data.list];
                if (res.state === 3) this.makeTable(res.athleteList.length);
                else this.makeTable();
                for (let i = 0; i < this.tableData.length; i++) {
                  this.$set(this.tableData[i], "name", "下拉/模糊查找");
                }
                res.athleteList.filter((item, index) => {
                  Object.assign(this.tableData[index], {
                    name: item.athleteName,
                    remarks: !item.remarks ? "非必填项" : item.remarks,
                    athleticsGroup: item.projectJson.athleticsGroup,
                    athleteId: item.athleteId,
                    athleticsIndividual1: !item.projectJson.athleticsIndividual1
                      ? "下拉选择"
                      : item.projectJson.athleticsIndividual1,
                    athleticsIndividual2: !item.projectJson.athleticsIndividual2
                      ? "下拉选择"
                      : item.projectJson.athleticsIndividual2,
                    athleticsRelay1: !item.projectJson.athleticsRelay1
                      ? "下拉选择"
                      : item.projectJson.athleticsRelay1,
                    athleticsRelay2: !item.projectJson.athleticsRelay2
                      ? "下拉选择"
                      : item.projectJson.athleticsRelay2
                  });
                  this.selectAthlete(item.athleteId, index, "name", true);
                });
              })
              .catch(err => {});
          } else {
            this.publishState = 0;
            this.makeTable();
          }
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getAthleteLists();
    this.getMatch();
    this.getCoachLists();
    window.addEventListener("keydown", e => {
      if (e.keyCode == "9") e.preventDefault();
    });
  },
  destroyed() {
    window.removeEventListener("keydown", event => {
      event.preventDefault();
    });
  }
};
</script>
<style lang="less" scoped>
.application_form_box {
  /deep/ .el-input.is-disabled .el-input__inner {
    background-color: rgba(192, 196, 204, 0.1);
  }
  .application_form {
    > li {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      > p {
        display: flex;
        align-items: center;
        margin-right: 120px;
        .basics {
          width: 70px;
          margin-right: 10px;
          text-align: right;
        }
      }
    }
  }
  .table_select_box {
    /deep/ .el-input__inner {
      line-height: 30px;
      height: 30px;
    }
    /deep/ .el-input__icon {
      line-height: 30px;
    }
  }
  footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
    .btns {
      margin: 0;
      color: #1e63b0;
      border: 1px solid #1e63b0;
    }
  }
}
</style>